import * as React from 'react';

const { default: emptyStar } = require("../../../assets/images/plans/git_star_grey@2x.png");
const { default: filledStar } = require("../../../assets/images/plans/git_star_gold@2x.png");

type GitHubStarsProps = {
    githubStars: number,
    numOfStars: number,
};

export function GitHubStars({ githubStars, numOfStars }: GitHubStarsProps) {
    const stars = [];

    for (let i = 0; i < githubStars; i++) {
        stars.push(numOfStars > i ? 1 : 0);
    }

    return <a
        className="plan-tile_github-stars"
        target="_blank"
        rel="noopener noreferrer"
        href="https://github.com/alan-ai"
    >
        <svg className="github-logo" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M17.5 1.52588e-05C7.83573 1.52588e-05 0 7.83575 0 17.5C0 25.2314 5.01325 31.7921 11.968 34.1046C12.8432 34.2669 13.1648 33.725 13.1648 33.2613C13.1648 32.844 13.1475 31.4647 13.1417 30.0042C8.27041 31.0619 7.24458 27.9409 7.24458 27.9409C6.44767 25.9182 5.30303 25.3792 5.30303 25.3792C3.71502 24.2925 5.42184 24.3157 5.42184 24.3157C7.17793 24.4403 8.10523 26.1182 8.10523 26.1182C9.66716 28.7929 12.1999 28.0191 13.1967 27.5729C13.3532 26.4427 13.8082 25.669 14.3066 25.2314C10.4206 24.7881 6.33466 23.287 6.33466 16.5843C6.33466 14.6746 7.01855 13.1127 8.13711 11.8869C7.95455 11.4464 7.35759 9.66718 8.30518 7.25618C8.30518 7.25618 9.77438 6.78673 13.1185 9.04994C14.5152 8.66163 16.0105 8.46748 17.5 8.46168C18.9866 8.46748 20.4848 8.66163 21.8844 9.04994C25.2256 6.78673 26.6919 7.25618 26.6919 7.25618C27.6453 9.66718 27.0455 11.4464 26.8629 11.8869C27.9844 13.1127 28.6624 14.6746 28.6624 16.5843C28.6624 23.3044 24.5678 24.7852 20.6731 25.2198C21.302 25.7617 21.8612 26.8281 21.8612 28.4596C21.8612 30.8011 21.841 32.6846 21.841 33.2613C21.841 33.7279 22.1568 34.2727 23.0436 34.1017C29.9925 31.7863 35 25.2285 35 17.5C35 7.83575 27.1643 1.52588e-05 17.5 1.52588e-05Z" fill="#25292E" />
        </svg>

        {stars.map((star, index) => <span key={index}>
            {star === 1 ?
                <img src={filledStar} /> :
                <img src={emptyStar} />}
        </span>)}
    </a>;
}